import React from 'react';
import LanguageHeader from 'src/components/container/LanguageHeader';
import { useAppState } from 'src/components/provider/AppStateProvider';
import { useAppointmentState } from 'src/components/provider/AppointmentProvider';
import ReportIssueLightbox from 'src/components/container/ReportIssueLightbox';
import Footer from 'src/components/ui/Footer';
import styles from './MainLayout.module.scss';

export default function MainLayout({ children }: WithChildren) {
  const { showHeader, showFooter, documentTitle } = useAppState();
  const { brandName } = useAppointmentState();

  return (
    <div className={styles.mainLayout}>
      <div aria-live="polite" className={styles.visuallyHidden}>
        {documentTitle}
      </div>
      {showHeader ? (
        <header>
          <LanguageHeader brandName={brandName} />
        </header>
      ) : null}
      <div className={`${styles.content}`}>
        {/* report issue lightbox success banner */}
        <div id="banner-container" className={styles.bannerContainer}></div>
        <ReportIssueLightbox />
        {children}
      </div>
      {showFooter ? <Footer /> : null}
    </div>
  );
}
